

    <ion-item lines="none" *ngIf="this._usernameAttributes === 'email'">
        <ion-label class="amplify-input-label amplify-input-label-ionic" for="emailField" position="stacked">{{ this.amplifyService.i18n().get('Email *') }}</ion-label>
        <ion-input type="text"
            #emailField
            class="amplify-form-input"
            type="email"
            placeholder="{{ this.amplifyService.i18n().get(this.getPlaceholder()) }}"
            (input)="setEmail($event.target.value)"
            data-test="email-input"
        ></ion-input>
    </ion-item> 
    <ion-item lines="none" *ngIf="this._usernameAttributes === 'phone_number'">
       <amplify-auth-phone-field-ionic
            (phoneFieldChanged)="onPhoneFieldChanged($event)"
        ></amplify-auth-phone-field-ionic>
    </ion-item>
    <ion-item lines="none" *ngIf="this._usernameAttributes !== 'email' && this._usernameAttributes !== 'phone_number'">
        <ion-label class="amplify-input-label amplify-input-label-ionic" for="usernameField" position="stacked">{{ this.amplifyService.i18n().get(getUsernameLabel()) }} *</ion-label>
        <ion-input type="text"
            #usernameField
            class="amplify-form-input"
            type="text"
            placeholder="{{ this.amplifyService.i18n().get(this.getPlaceholder()) }}"
            (input)="setUsername($event.target.value)"
            data-test="username-input"
        ></ion-input>
    </ion-item>

